import { render, staticRenderFns } from "./SortTaskControl.vue?vue&type=template&id=29e5bf58&"
import script from "./SortTaskControl.vue?vue&type=script&lang=js&"
export * from "./SortTaskControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29e5bf58')) {
      api.createRecord('29e5bf58', component.options)
    } else {
      api.reload('29e5bf58', component.options)
    }
    module.hot.accept("./SortTaskControl.vue?vue&type=template&id=29e5bf58&", function () {
      api.rerender('29e5bf58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/SortTaskControl.vue"
export default component.exports